import headerTheme from '@/inits/components/header/header-theme';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';

const init = () => {
    if (!DEVICE_WIDTH.isDesktop) {
        const posts = Array.from(document.querySelectorAll('.n-post'));

        posts.forEach((post) => {
            post.classList.add('js-header-theme-trigger');

            if (post.classList.contains('n-post--dark')) {
                post.setAttribute('data-theme', 'dark');
            } else {
                post.setAttribute('data-theme', 'light');
            }
        });

        headerTheme.destroy();
        headerTheme.init();
    }
};

const _module = { init };

export default _module;
